import {Flex, Heading, Icon, Text, Box} from '@chakra-ui/react';
import {
  IconUser,
  IconMapPin,
  IconBrush,
  IconCertificate,
  IconDimensions,
  IconMathXDivideY2,
} from '@tabler/icons';
import React from 'react';
import Image from 'next/image';

export const DetailsSection: React.FC = () => {
  return (
    <Flex
      maxW="1120px"
      width="100%"
      margin="0 auto"
      py={{base: '30px', md: '60px'}}
      px={{base: '20px', md: 0}}
      flexDirection="column"
      color="white"
    >
      <Heading size="xl" fontWeight="600" mb={{base: '20px', md: '40px'}}>
        Valentineʼs Day Mascara
      </Heading>
      <Flex flexDirection={{base: 'column', md: 'row'}} position="relative">
        <Flex
          flexDirection="column"
          flex={1}
          pr={{base: 0, md: '24px'}}
          mb={{base: '40px', md: 0}}
        >
          <Flex
            flexDirection="row"
            alignItems="center"
            mb={{base: '20px', md: '24px'}}
          >
            <Icon
              as={IconUser}
              height="30px"
              width="30px"
              p="5px"
              mr="20px"
              backgroundColor="rgba(31, 211, 197, 0.24)"
              borderRadius="50%"
            />
            <Text fontWeight="600">Banksy (Born 1976)</Text>
          </Flex>
          <Flex
            flexDirection="row"
            alignItems="center"
            mb={{base: '20px', md: '24px'}}
          >
            <Icon
              as={IconMapPin}
              height="30px"
              width="30px"
              p="5px"
              mr="20px"
              backgroundColor="rgba(31, 211, 197, 0.24)"
              borderRadius="50%"
            />
            <Text fontWeight="600">Margate, Kent, United Kingdom</Text>
          </Flex>
          <Flex
            flexDirection="row"
            alignItems="center"
            mb={{base: '20px', md: '24px'}}
          >
            <Icon
              as={IconBrush}
              height="30px"
              width="30px"
              p="5px"
              mr="20px"
              backgroundColor="rgba(31, 211, 197, 0.24)"
              borderRadius="50%"
            />
            <Text fontWeight="600">
              Stencil & Spraypaint on painted brickwork and found materials
            </Text>
          </Flex>
          <Flex
            flexDirection="row"
            alignItems="center"
            mb={{base: '20px', md: '24px'}}
          >
            <Icon
              as={IconCertificate}
              height="30px"
              width="30px"
              p="5px"
              mr="20px"
              backgroundColor="rgba(31, 211, 197, 0.24)"
              borderRadius="50%"
            />
            <Text fontWeight="600">Condition, Authentic</Text>
          </Flex>
          <Flex
            flexDirection="row"
            alignItems="center"
            mb={{base: '20px', md: '24px'}}
          >
            <Icon
              as={IconDimensions}
              height="30px"
              width="30px"
              p="5px"
              mr="20px"
              backgroundColor="rgba(31, 211, 197, 0.24)"
              borderRadius="50%"
            />
            <Text fontWeight="600">Dimensions 230 x 375 x 30cm approx</Text>
          </Flex>
          <Flex
            flexDirection="row"
            alignItems="center"
            mb={{base: '20px', md: '24px'}}
          >
            <Icon
              as={IconMathXDivideY2}
              height="30px"
              width="30px"
              p="5px"
              mr="20px"
              backgroundColor="rgba(31, 211, 197, 0.24)"
              borderRadius="50%"
            />
            <Text fontWeight="600">
              60,000 in total, up to 27,000 pieces available to be purchased
            </Text>
          </Flex>
        </Flex>
        <Flex
          flexDirection="column"
          flex={1}
          zIndex={5}
          pl={{base: 0, md: '24px'}}
        >
          <Text>
            A 1950s housewife with a black eye and a missing tooth closes a
            chest freezer with the legs of a man protruding from it. The piece
            implies a scenario of domestic violence where the abused partner has
            allegedly murdered her oppressor and hidden him in the freezer.
          </Text>
          <br />
          <Text>
            Having been safely removed from the original wall in April 2023,
            conservator Thomas Organ of Arte Conservation stabilised and
            restored the piece. The piece now resides within the Dreamland
            amusement park in Margate, where it will remain on display for the
            rest of 2023.
          </Text>
        </Flex>
        <Box
          position="absolute"
          bottom="-60px"
          right="-140px"
          display={{base: 'none', md: 'block'}}
        >
          <Image
            src="/assets/graffiti-heart.png"
            height="432px"
            width="320px"
          />
        </Box>
      </Flex>
    </Flex>
  );
};
